import { Pipe, PipeTransform } from '@angular/core'
import { RentalStatus } from '@tokeet-frontend/tv3-platform'

@Pipe({
  name: 'rentalStatus',
})
export class RentalStatusIconPipe implements PipeTransform {
  transform(status: RentalStatus) {
    switch (status) {
      case RentalStatus.IN_PROGRESS:
        return $localize`In Progress`
      case RentalStatus.READY:
        return $localize`Ready`
      case RentalStatus.NOT_READY:
        return $localize`Not Ready`
      default:
        return $localize`Ready`
    }
  }
}
